import {
  makeType,
  initLog
} from "../core/base";

import {
  Stream
} from "../core/dispatcher-flyd";

import {
  modelChanged,
} from "../components/common";

const SELECTED = 's_selected-item'
const ITEM = 'item-selector';
const HIDE = 'hide';

const proto = {
  name: 'Toggle',
  initLog,

  init(toggle) {
    return {
      closed_label: toggle.textContent,
      open_label: toggle.dataset.label ?  toggle.dataset.label : toggle.textContent,
      open: false,
    }
  },

  update(msg, model) {
    // this.log.warn(`msg: ${msg.type} model:`, Object.assign({}, model));

    switch (msg.type) {
      case "click":
        if (model.open === false) {
          model.open = true;
          this.toggle.textContent = model.open_label;
        } else {
          model.open = false;
          this.toggle.textContent = model.closed_label;
        }
        break;
      case "change":
        if (model.open === false) {
          model.open = true;
          // this.toggle.textContent = model.open_label;
        // } else {
          // model.open = false;
          // this.toggle.textContent = model.closed_label;
        }
        break;
        // default:
        //     this.log.info("unhandled event:", msg.type, msg);
    }
    return model;
  },

  view(model) {
    // this.log.warn(`view: state:`, Object.assign({}, model));
    if (model.open === true) {
      this.target.removeClass(HIDE);
      // if (this.toggle)
    } else {
      this.target.addClass(HIDE);
    }
    return model;
  },

  initialize(dom) {
    // this.initLog();
    this.toggle = dom;
    this.target = document.findByRole(this.toggle.dataset.target)[0];
    // this.toggle = this.dom.findByRole("menu-close")[0];


    // this.input = this.dom.getElement('input');
    // this.log.warn("toggle:", this.toggle);
    // this.log.warn("target:", this.target);

    let currentModel = this.init(this.toggle);

    this.eventStream = new Stream();

    this.eventStream.map(msg => {
      let model = Object.assign({}, currentModel);
      model = this.update(msg, model);
      if (modelChanged(currentModel, model)) {
        model = this.view(model);
      }
      currentModel = model;
    });

    let type = this.toggle.dataset.type === undefined ? "click" : this.toggle.dataset.type;

    this.toggle.addEvent(type, this.eventStream.stream);
    // this.openToggle.addEvent("click", this.eventStream.stream);
  },


};

const Toggle = makeType(proto);

// console.log(`sliding menu?`, Toggle);

export default Toggle;

UI.register("toggle", Toggle);


// console.log(`here`);
